import { type ReactNode } from 'react'
import { Icon, type IconName } from '#app/components/ui/icon'
import { cn } from '#app/utils/misc'

type CalloutTone = 'tip' | 'meaning'

/**
 * Reassuring, jargon-free asides.
 * `tip` (green) for guidance; `meaning` (violet) for "what this means".
 */
export function Callout({
	tone = 'tip',
	title,
	icon,
	className,
	children,
}: {
	tone?: CalloutTone
	title?: string
	icon?: IconName
	className?: string
	children: ReactNode
}) {
	const isTip = tone === 'tip'
	return (
		<div
			className={cn(
				'rounded-2xl border p-5 sm:px-6',
				isTip
					? 'border-[#DCEFE6] bg-[#F0FAF5]'
					: 'bg-brand-wash border-[#E4DFF6]',
				className,
			)}
		>
			{title ? (
				<div
					className={cn(
						'mb-2 flex items-center gap-2 font-mono text-[11.5px] font-semibold tracking-[0.06em] uppercase',
						isTip ? 'text-gained-ink' : 'text-brand',
					)}
				>
					{icon ? <Icon name={icon} className="size-4" /> : null}
					{title}
				</div>
			) : null}
			<div
				className={cn(
					'text-[15px] leading-relaxed',
					isTip ? 'text-[#2B4A3B]' : 'text-[#2B2A31]',
				)}
			>
				{children}
			</div>
		</div>
	)
}
